
function initJobOpeningCards() {
    const cards = document.querySelectorAll(".job-opening__card");

    cards.forEach(card => {
        const btn = card.querySelector(".job-opening__hidden-card");
        const blocks = card.querySelectorAll(".job-opening__card-body");

        if (!btn || !blocks.length) return;

        btn.onclick = () => {
            btn.classList.toggle("_showmore-active");
            blocks.forEach(block => block.classList.toggle("_show"));
        };
    });
}

function initHowWorkObserver() {
    const items = document.querySelectorAll(".how-work__item");

    if (!items.length) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("_anim");
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.3 });

    items.forEach(item => observer.observe(item));
}

document.addEventListener("DOMContentLoaded", () => {
    initJobOpeningCards();
    initHowWorkObserver();
});
